<template>
  <sliding-window>
    <div slot="panel">
      <violet-bar>Kit presse</violet-bar>
      <div class="squarebox">
        <h3>Options</h3>
        <hr />
        <div>
          <div class="field">
            <label for="" class="label"
              ><input type="checkbox" v-model="options.humans" />&nbsp;Inclure
              "Moyens humains"</label
            >
          </div>
          <div class="field">
            <label for="" class="label"
              ><input type="checkbox" v-model="options.hardware" />&nbsp;Inclure
              "Moyens matériels"</label
            >
          </div>
          <div class="field">
            <label for="" class="label"
              ><input type="checkbox" v-model="options.axes" />&nbsp;Vue en axes
              ?</label
            >
          </div>
        </div>
        <hr />
        <div class="field">
          <div class="control" style="position:relative;">
            <label for="" class="label">Adresse e-mail (interne) de réception :</label>
            <input class="input" type="email" v-model="email">
            <span @click="email = ''" class="delete is-small" style="position: absolute; right: 5px; bottom: 5px; display: block;"></span>
          </div>
        </div>
        <div class="field">
          <div class="control">
            <button
              class="button"
              v-show="valid_email"
              @click="generate"
              :class="loading ? 'is-loading' : ''"
            >
              <i class="fa fa-print"></i>&nbsp;générer le kit
            </button>
          </div>
        </div>
        <div class="control" v-if="render">
          <hr />
          Votre Kit Presse vous sera envoyé par e-mail une fois généré.
        </div>
      </div>
      <div class="control">
        <router-link class="button" :to="'/home'"
          ><i class="fa fa-arrow-left"></i>&nbsp;accueil
        </router-link>
      </div>
    </div>
    <page-format-handler>
      <div class="squarebox" style="width: 21cm; margin-top: 1cm;">
        <h3>Arborescence de sortie</h3>
        <hr />
        <ul class="Arborescence" style="font-size: 11px;">
          <li>/</li>
          <li>
            /agence
            <ul>
              <li>/presentation.pdf</li>
            </ul>
          </li>
          <li>
            /projets
            <ul>
              <li v-for="p in projects">
                /{{ p.slug }}
                <ul v-if="options.axes">
                  <li>
                    /axes-de-travail
                    <ul>
                      <li v-for="axe in p.contents_d">/{{ axe.name }}
                        <ul>
                          <li style="padding-left:1.5em;">/images
                            <ul
                              style="margin-left: 1.5em; display: flex;flex-wrap: wrap;"
                            >
                              <li v-for="i in axe.pictures">
                                <div
                                  style="display: inline-block;width: 30px; margin-right: 4px;"
                                >
                                  <div style="background: gray; height: 30px;"></div> 
                                </div>
                              </li>
                            </ul>
                          </li>
                          <li>/texte.txt</li>
                          <li>/crédits.txt</li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li>/crédits.txt</li>
                </ul>
                <ul v-else>
                  <li style="padding-left:1.5em;">
                    /images
                    <ul
                      style="margin-left: 1.5em; display: flex;flex-wrap: wrap;"
                    >
                      <li v-for="i in p.pictures_ids">
                        <div
                          style="display: inline-block;width: 30px; margin-right: 4px;"
                        >
                           <div style="background: gray; height: 30px;"></div> 
                        </div>
                      </li>
                    </ul>
                  </li>
                  <li>/texte.txt</li>
                  <li>/crédits.txt</li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </page-format-handler>
  </sliding-window>
</template>

<script>
  import SlidingWindow from "./PrintComponents/Workspace/SlidingWindow";
  import {types as t} from "../../store/actions/projects";
  import {rem} from "../../storage/storage";
  import {types} from "../../store/actions/render";
  import PageFormatHandler from "./PrintComponents/Page/PageFormatHandler";
  import {formatDateFrench, formatNumbers, mapNames} from "./../../util/func";
  import ApiPicture from "./../../components/Form/ApiPicture";
  import VioletBar from "../Projects/VioletBar";
  import {defaultApiUrl} from "../../api";

  export default {
  name: "Index",
  components: {
    VioletBar,
    PageFormatHandler,
    ApiPicture,
    SlidingWindow
  },
  data() {
    return {
      projects: [],
      options: {
        humans: false,
        hardware: false,
        axes: false,
        high_def: false
      },
      email: "soft@scalene.fr",
      sortedProjects: [],
      loading: false,
      render: null,
      ready: false,
      kit: null,
      api_url: defaultApiUrl.replace('/api/', ''),
      pm: {
        format: "A4"
      }
    };
  },
  props: {
    ids: {}
  },
  computed: {
    pagesLength() {
      return this.projects.length;
    },
    valid_email() {
      return this.email.length > 6 && this.email.indexOf('@') !== -1;
    }
  },
  methods: {
    formatNumbers,
    mapNames,
    formatDateFrench,
    sortProjects() {
      return this.projects;
    },
    async generate() {
      this.loading = 1;
      this.render = await this.$store.dispatch(types.EXPORT_ZIP, {projects: this.projects, options: {...this.options, email: this.email}});
      this.loading = 0;
    }
  },
  async mounted() {
    this.projects = await this.$store.dispatch(
      t.GET_PROJECTS_BY_IDS_D,
      this.ids
    );
    this.sortedProjects = this.projects;
    rem("payload");
  }
};
</script>

<style lang="scss">
.ScESummary {
  font-size: 11px;

  h2 {
    font-size: 18px;
  }

  h3 {
    font-size: 14px;
  }
}

.Arborescence {
  li {
    line-height: 1.3;
    font-family: monospace;
    padding-left: .75em;
    background: transparentize(#31287c, 0.9);
  }
}
</style>
